module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/Layout.ejs -->\n<div class="row wrapper page-heading employee-edit-header">\n\n</div>\n\n<div class="wrapper wrapper-content wrapper-tabs employee-edit-content">\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/Layout.ejs
// module id = 775
// module chunks = 1